/* Menu Entry Template:
{
  name: 'Name that appears in menu',
  id: 'Unique identifier for specific tile',
  content: [{
    id: 'data-src-ID',
    type: 'line/bar/dotplot/table/image'
  }],
  components: ['toggles', 'tabs']
},
*/


export default {
  label: "Indirect Treatment Comparison (ITC)",
  id: 'itc',
  sidebar: [
    {
      li: 'Study Overview',
      subList: [
        {
          name: 'Study Design',
          tileId: 'itc-study-design',
          content: [{
            id: 'itc-study-design',
            type: 'image',
          }],
          enableScroll: false,
          components: [],
        },
        {
          name: 'Study Characteristics',
          tileId: 'itc-study-characteristics',
          content: [{
            id: 'itc-study-char',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
        {
          name: 'Patient Characteristics',
          tileId: 'itc-patient-characteristics',
          content: [{
            id: 'itc-patient-char',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
      ],
    },
    {
      li: 'Efficacy',
      subList: [
        {
          name: 'ESS',
          tileId: 'itc-ess',
          content: [{
            id: 'itc-ess',
            type: 'image',
          }],
          enableScroll: false,
          components: [],
        },
        {
          name: 'MWT',
          tileId: 'itc-mwt',
          content: [{
            id: 'itc-mwt',
            type: 'image',
          }],
          enableScroll: false,
          components: [],
        },
        {
          name: 'CGI-C',
          tileId: 'itc-cgi-c',
          content: [{
            id: 'itc-cgi-c',
            type: 'image',
          }],
          components: [],
        },
      ],
    },
    {
      li: 'Safety',
      subList: [
        {
          name: 'TEAE Risk Difference',
          tileId: 'itc-teae-risk-difference',
          content: [{
            id: 'itc-teae-risk-diff',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
      ],
    },
  ],
};
